import  { useState } from 'react'
import Logo from '../assets/logo.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import image_1 from '../assets/disney-150x150.png'
import image_2 from '../assets/image_2023_12_06T15_17_05_311Z.png'
import image_3 from '../assets/btc-150x150.png'
import image_4 from '../assets/meat-150x150.png'
import image_5 from '../assets/image3-150x150.png'
import image_6 from '../assets/bobmarley-150x150.png'

import channel_1 from '../assets/channel_ld_198.png'
import channel_2 from '../assets/channel_ld_780.png'
import channel_3 from '../assets/channel_ld_375.png'

import Mobibox from '../assets/mobiboxlogo.png'

import apple from '../assets/appleicon.png'
import playstore from '../assets/playstore.png'

import visa from '../assets/visa.png'
import mastercard from '../assets/mastercard.png'


import {
  Video,
  Flame,
  Ban,
  PlaySquare, ArrowDownToLine, User
} from 'lucide-react';

export default function LandingPage() {

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const [loading, setLoading] = useState(false)

  const [ResetErrorMessage, setResetErrorMessage] = useState("")
  const [resetPhone, setResetPhone] = useState("")


  const [ErrorMessage, setErrorMessage] = useState("")
  const [ShowError, setShowErrorMessage] = useState(false)


  function login() {
    setLoading(true)
    fetch(`https://apiv2.mobileartsme.com/login?serviceid=1&phonenumber=${username}&password=${password}&type=signin&country=lb`)
      .then(response => response.json())
      .then(data => {
        console.log(data);

        if (data.Error !== 0) {
          setErrorMessage(data.Result);
          setShowErrorMessage(true);
        } else {
          if (data.Result.Status === 0) {
            // Store user data along with the username in localStorage
            const userData = {
              ...data.Result,
              phone: username // Add the username field
            };
            localStorage.setItem('AV_User_Data', JSON.stringify(userData));

            window.location.href = "/home";
          } else {
            setErrorMessage(data.Result.Description);
            setShowErrorMessage(true);
          }

        }
        setLoading(false)

      })
      .catch(error => {
        setLoading(false)

        console.error("Login failed:", error);
        setErrorMessage("An error occurred. Please try again.");
        setShowErrorMessage(true);
      });
  }


  function resetPassword() {

    if (resetPhone === "") {
      setResetErrorMessage("Please enter your phone number !")

    } else {
      fetch(`https://apiv2.mobileartsme.com/av_forgetpass?phonenumber=${resetPhone}&apisource=1&language=LB`)
        .then(res => res.json())
        .then(response => {
          setResetErrorMessage(response.result)
        })
    }

  }


  return (
    <>
      <section id="hero" >
        <div className="container d-flex flex-column justify-content-center py-5" style={{ height: '100vh', position: 'relative', zIndex: '2' }}  >

          <div style={{ position: 'absolute', top: '2rem', right: '0' }} >
            <button style={{ marginRight: '10px' }} onClick={() => window.location.href = '#footerlogin'}>Login <User /></button>

          </div>

          <div >
            <img src={Logo} alt="amazing videos" width={'70px'} height={'60px'} />
            <h1 className='bold pt-4' >Totally Funny <br></br>
              <span className='spangreen' >& Amazing</span></h1>

            <p>Discover movie news, trailers, fresh daily content, <br></br> live streaming, and other videos in different languages</p>

            <div className='pt-2 d-flex flex-row gap-2'>
              <button onClick={() => window.location.href = '#footerlogin'} >Download our App <ArrowDownToLine /></button>
            </div>

          </div>

        </div>
      </section>





      <section data-aos="zoom-in" className="py-5 my-5 text-white">
        <div className="container">
          <div className="row align-items-start">

            {/* Left Column */}
            <div className="col-12 mb-4">
              <h2>
                Discover. <span className="spangreen">Watch.</span> Repeat.
              </h2>
              <p className="my-2">
                Whether you're into documentaries, music, sports, finance, tech, lifestyle, or learning,<br />
                our curated video library brings the best of every world right to your screen.
              </p>
            </div>

            {/* Features Grid */}
            <div className="col-12 mt-2">
              <div className="row row-cols-1 row-cols-sm-1 row-cols-lg-2 g-3">


                <div className="col">
                  <div className="feature-card p-3 border-0 d-flex flex-row align-items-start ">
                    <Video className="text-white me-3 col-icon" color="#36CB9E" size={55} />
                    <div>
                      <label className="mb-1 fw-bold fs-5">Curated Content</label>
                      <p className="mb-0 small">Handpicked videos across dozens of genres.</p>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="feature-card p-3 border-0 d-flex flex-row align-items-start ">
                    <Flame className="text-white me-3 col-icon" color="#36CB9E" size={55} />
                    <div>
                        <label className="mb-1 fw-bold fs-5">Trending Daily</label>
                      <p className="mb-0 small">Fresh content, updated daily just for you.</p>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="feature-card p-3 border-0 d-flex flex-row align-items-start ">
                    <Ban className="text-white me-3 col-icon" color="#36CB9E" size={55} />
                    <div>
                      <label className="mb-1 fw-bold fs-5">No Ads, Just Content</label>
                      <p className="mb-0 small">Enjoy uninterrupted viewing — always ad-free.</p>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="feature-card p-3 border-0 d-flex flex-row align-items-start ">
                    <PlaySquare className="text-white me-3 col-icon" color="#36CB9E" size={55} />
                    <div>
                      <label className="mb-1 fw-bold fs-5">Watch Your Way</label>
                      <p className="mb-0 small">Stream on-demand or join live broadcasts.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>




      <section data-aos='zoom-in' className='py-5 my-5' >
        <div className='container' >

          <div className='d-flex flex-row align-items-center gap-4 mb-5' >

            {/* <svg aria-hidden="true" className="e-font-icon-svg e-fas-video" width={'60px'} fill='var(--green)' viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v358.4C0 426.6 21.4 448 47.8 448h2
              88.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157
              .4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"></path></svg> */}

            <div >
              <h2>Explore <span className='spangreen' >Unlimited</span> Video Categories</h2>
              <p>Discover unlimited video categories, designed for popular genres and new explorations.</p>
            </div>

          </div>


          <Swiper
            spaceBetween={50}
            slidesPerView={4}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
            breakpoints={{
              320: { slidesPerView: 2 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            <SwiperSlide>
              <img className='swiperimage' src={image_1} alt="Disney Show" />
              <p>Disney Show</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage' src={image_2} alt="Unlimited Football Matches" />
              <p>Unlimited Football Matches</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage' src={image_3} alt="Best Of BTC" />
              <p>Best Of BTC</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage' src={image_4} alt="Pro Cooking videos" />
              <p>Pro Cooking videos</p>
            </SwiperSlide>


            <SwiperSlide>
              <img className='swiperimage' src={image_5} alt="LMAO - Stand up Comedy" />
              <p>LMAO - Stand up Comedy</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage' src={image_6} alt="Bob Marley : 1 Love" />
              <p>Bob Marley : 1 Love</p>
            </SwiperSlide>

          </Swiper>


        </div>
      </section>


      <section data-aos='zoom-in' className='py-5 my-5' >
        <div className='container' >

          <div className='d-flex flex-row align-items-center gap-4 mb-5' >

            {/* <svg aria-hidden="true" className="e-font-icon-svg e-far-file-video" width={'60px'} fill='var(--green)' viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21
              .49 0 48v416c0 26.51 21.49 48 48 48h358c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-
              14.059-33.941zM332.118 135H256V51.882L332.118 135zM48 464V48h160v104c0 13.255 10.745 
              24 24 24h104v358H48zm235.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 
              0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.
              674C356.704 397.318 304 390.35 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"></path></svg> */}

            <div >
              <h2> <span className='spangreen' >Live Streaming</span>  Channels</h2>
              <p>Dive into live streaming. Connect and share in real time, showcasing your unique view.</p>
            </div>

          </div>


          <Swiper
            spaceBetween={50}
            slidesPerView={4}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
            breakpoints={{
              320: { slidesPerView: 2 },  // 1 slide for small screens (phones)
              480: { slidesPerView: 2 },  // 2 slides for small tablets
              768: { slidesPerView: 3 },  // 3 slides for tablets
              1024: { slidesPerView: 4 }, // 4 slides for larger screens
            }}
          >
            <SwiperSlide>
              <img className='swiperimage channel_image' src={channel_1} alt="Joke TV" />
              <p className='' >Joke TV</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage channel_image' src={channel_2} alt="Knowledge Plus" />
              <p className='' >Knowledge Plus</p>
            </SwiperSlide>

            <SwiperSlide>
              <img className='swiperimage channel_image' src={channel_3} alt="Movies News" />
              <p className='' >Movies News</p>
            </SwiperSlide>



          </Swiper>


        </div>
      </section>



      <footer id='footerlogin' data-aos='zoom-in' className="text-light my-5 pt-5" style={{ borderTop: '1px solid #ffffff33' }}>
        <div className="container">

          <img src={Logo} alt='amazing videos' />


          <div className="row pt-4">

            <div className="col-lg-5 mb-3">

              <label style={{ fontSize: '1.6rem' }}>Sign In</label>

              <input type="tel" className="form-control my-2 mt-4" placeholder="Username" onChange={(e) => setUsername(e.target.value)} />

              <div className='d-flex gap-2' >
                <input type="password" className="form-control" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                <button onClick={() => login()} >
                  {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Login"}
                </button>
              </div>



              <button className='btn p-0 my-3' style={{ textDecoration: 'none', color: 'white', boxShadow: 'none' }} data-bs-toggle="modal" data-bs-target="#exampleModal">
                Forgot Password?
                <p style={{ color: 'red' }} >{ErrorMessage}</p>
              </button>


            </div>

            <div className="col-lg-1 mb-3"></div>

            <div className="col-lg-3 mb-3">
              <label style={{fontSize:"1.4rem" , fontWeight:'bold'}} >Links</label>

              <div className='mt-4 d-flex flex-column gap-2' >

                <p><a href="/Contact" className="text-light text-decoration-none" >
                  Contact Us
                </a></p>

                {/* <p><a className="text-light text-decoration-none" data-bs-toggle="offcanvas" href="#Terms&Conditions" role="button" aria-controls="offcanvasExample" aria-fg="false">
                  Terms and Conditions
                </a></p>

                <p><a className="text-light text-decoration-none" data-bs-toggle="offcanvas" href="#PrivacyPolicy" role="button" aria-controls="offcanvasExample" aria-hidden="false">
                  Pirvacy Policy
                </a></p> */}


                <p>
                  <a
                    className="text-light text-decoration-none"
                    data-bs-toggle="offcanvas"
                    href="#Terms&Conditions"
                    role="button"
                    aria-controls="TermsConditions"
                    aria-expanded="false"
                  >
                    Terms and Conditions
                  </a>
                </p>

                <p>
                  <a
                    className="text-light text-decoration-none"
                    data-bs-toggle="offcanvas"
                    href="#PrivacyPolicy"
                    role="button"
                    aria-controls="PrivacyPolicy"
                    aria-expanded="false"
                  >
                    Privacy Policy
                  </a>
                </p>


                <div>
                  <label className='mt-4'  style={{fontSize:"1.4rem" , fontWeight:'bold'}} >Payment</label>
                  <div>
                    <img style={{ width: '30px' }} src={visa} alt="visa card" />
                    <img style={{ width: '30px' }} src={mastercard} alt="master card" />
                  </div>
                </div>

              </div>
            </div>


            <div className="col-lg-3 mb-3">
              <label style={{fontSize:"1.4rem" , fontWeight:'bold'}} >Download Our App</label>

              <div className='d-flex flex-row gap-2 flex-wrap mt-3' >

                <a className='os-button' href='https://apps.apple.com/app/id1463392490' target='_blank' >
                  <img src={apple} alt='appstore' />
                  <div>
                    <p>Download on the</p>
                    <span>App Store</span>
                  </div>
                </a>

                <a className='os-button' href='https://play.google.com/store/apps/details?id=amazing.watch.videos' target='_blank' >
                  <img style={{ width: '30px' }} src={playstore} alt='playstore' />
                  <div>
                    <p>Get it on</p>
                    <span>Google Play</span>
                  </div>
                </a>

                <a className='os-button' href='https://appgallery.huawei.com/#/app/C105963133' target='_blank' >


                  <svg xmlns="http://www.w3.org/2000/svg"
                    width="30px" height="30px" viewBox="0 0 40 40" version="1.1">

                    <defs>
                      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                        <stop stopColor="transparent" offset="0%" />
                        <stop stopColor="transparent" offset="100%" />
                      </linearGradient>
                    </defs>
                    <g id="ic_ag" stroke="white" strokeWidth="0.5" fill="none" fillRule="evenodd">
                      <g id="编组" transform="translate(2.000000, 2.000000)">
                        <path d="M10.1009995,0 C2.70511277,0 0,2.70464098 0,10.0990356 L0,25.9009714 C0,33.295359 2.70511277,36 10.1009995,36 L25.894186,36 C33.3598634,36 36,33.295359 36,25.9009714 L36,10.0990356 C36,2.70464098 33.2948872,0 25.8990005,0 L10.1009995,0 Z" id="Fill-1" fill="url(#linearGradient-1)" />
                        <path d="M15.7030515,20.879251 L17.1483192,20.879251 L16.423226,19.1929607 L15.7030515,20.879251 Z M15.3471598,21.7290511 L14.9183536,22.7102135 L13.9421108,22.7102135 L16.0181459,18.0003593 L16.8618698,18.0003593 L18.929514,22.7102135 L17.9272303,22.7102135 L17.5039216,21.7290511 L15.3471598,21.7290511 Z M31.0564529,22.7067407 L32,22.7067407 L32,18 L31.0564529,18 L31.0564529,22.7067407 Z M27.3010716,20.6848126 L29.0403117,20.6848126 L29.0403117,19.8266216 L27.3010716,19.8266216 L27.3010716,18.8619524 L29.8258776,18.8619524 L29.8258776,18.0034721 L26.3578138,18.0034721 L26.3578138,22.7099234 L29.9167313,22.7099234 L29.9167313,21.8514431 L27.3010716,21.8514431 L27.3010716,20.6848126 Z M23.5520559,21.2409296 L22.4823553,18 L21.7017082,18 L20.6320075,21.2409296 L19.5909518,18.0026041 L18.5730436,18.0026041 L20.2159325,22.7135169 L21.0073552,22.7135169 L22.0787219,19.6188734 L23.1501586,22.7135169 L23.9484556,22.7135169 L25.5870044,18.0026041 L24.5954263,18.0026041 L23.5520559,21.2409296 Z M12.5017619,20.697833 C12.5017619,21.464013 12.121276,21.8734332 11.4303252,21.8734332 C10.7356129,21.8734332 10.3531017,21.4521499 10.3531017,20.6651373 L10.3531017,18.0031835 L9.39682343,18.0031835 L9.39682343,20.697833 C9.39682343,22.0233135 10.1334904,22.7834165 11.4173048,22.7834165 C12.7138502,22.7834165 13.4571721,22.0088456 13.4571721,20.6584824 L13.4571721,18.0003593 L12.5017619,18.0003593 L12.5017619,20.697833 Z M7.11535481,18.0003593 L8.07105434,18.0003593 L8.07105434,22.7131062 L7.11535481,22.7131062 L7.11535481,20.799103 L4.95627822,20.799103 L4.95627822,22.7131062 L4,22.7131062 L4,18.0003593 L4.95627822,18.0003593 L4.95627822,19.9012721 L7.11535481,19.9012721 L7.11535481,18.0003593 Z" id="Fill-1" fill="#FFFFFF" />
                        <path d="M18,12 C14.6912616,12 12,9.30844907 12,6 L12.8475116,6 C12.8475116,8.84085648 15.1591435,11.1521991 18,11.1521991 C20.8408565,11.1521991 23.1524884,8.84085648 23.1524884,6 L24,6 C24,9.30844907 21.3084491,12 18,12" id="Fill-3" fill="#FFFFFF" />
                      </g>
                    </g>
                  </svg>

                  <div>
                    <p>Download on the</p>
                    <span>App Gallery</span>
                  </div>
                </a>

              </div>


            </div>


          </div>


          <hr className='py-2' ></hr>

          <div className="text-center" >
            <p className="mb-1">Powered By</p>
            <img className='my-3' src={Mobibox} alt="mobibox" />
            <p>Mobi Box GmbH, Kemperplatz 1, Sony center 10785, Berlin, DE</p>

          </div>
        </div>
      </footer>




      {/* Privacy Policy */}

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="PrivacyPolicy" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">Privacy Policy</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <iframe style={{ height: '100%' }} src=' https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/PrivacyPolicy.html?service=amazingvideos' />
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="Terms&Conditions" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">Terms and Conditions</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <iframe style={{ height: '100%' }} src='https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/Terms%26Conditions.html?service=amazingvideos' />
      </div>


      {/* Reset Password Modal */}
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5 text-dark" id="exampleModalLabel">Reset Password</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <p className='text-dark' >Enter your number and we will send you your new password</p>
              <input type="phone" className="form-control my-4" placeholder="Phone Number" onChange={(e) => setResetPhone(e.target.value)} />
              <p className='text-dark' >{ResetErrorMessage}</p>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" onClick={() => resetPassword()}>Reset</button>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}
